export { type RadioChangeEvent } from 'antd/lib/radio/interface';

import type { ComponentProps } from 'react';
import RadioOriginal from './Radio';
import RadioButton from './radio-button';
import RadioGroup from './radio-group';

type P = ComponentProps<typeof RadioOriginal>;

const Radio = (props: P) => <RadioOriginal {...props} />;

Radio.Group = RadioGroup;
Radio.Button = RadioButton;

export { Radio };
